import { Rule } from "antd/es/form";
import { MasterConfigs } from "../../interfaces/entity";

const phoneNumberValidator: Rule = {
    validator: (_, value) => {
        const phoneRegex = /^[0-9]{10}$/;
        if (!value) {
            return Promise.reject(new Error("Phone number is required"));
        } else if (!phoneRegex.test(value)) {
            return Promise.reject(new Error("Please enter a valid 10-digit phone number"));
        }
        return Promise.resolve();
    },
};

const ContactConfig: MasterConfigs = {
    api: () => "/users",
    maskClosable: false,
    modalTitle: () => "Edit User",
    getFormColumns: () => [
        {
            label: "Work Email",
            name: "workEmail",
            type: "text",
            inputProps: { disabled: true }
        },
        {
            label: "Persnal Email",
            name: "email",
            type: "text",
            inputProps: { disabled: true }
        },
        {
            label: "Work Phone",
            name: "mobile",
            type: "text",
            inputProps: { disabled: true }
        },
        {
            label: "Residential Contact Number",
            name: "residentialContactNumber",
            type: "text",
            rules: [phoneNumberValidator]
        },
        {
            label: "Emergency Contact Number",
            name: "emergencyContactNumber",
            type: "text",
            rules: [phoneNumberValidator]
        },
    ]
}

export default ContactConfig;